import { useCallback, useState } from 'react';

export const useGoogleAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const startGoogleOAuthLogin = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      window.location.href = `${apiUrl}/google-auth/login`;
    } catch (err) {
      console.error('[Google OAuth] Error:', err);
      setError('No se pudo iniciar sesión con Google.');
      setLoading(false);
    }
  }, []);

  return {
    startGoogleOAuthLogin,
    loading,
    error,
  };
};

export default useGoogleAuth;